import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';
import InputPassword from '../widgets/input-password/InputPassword';

export interface Props extends DialogProps {
  placeholder?: string;
  confirm?: boolean;
  placeholderConfirm?: string;
  validatePassword?: (password: string, confirmPassword?: string) => boolean;
  action?: (password: string, confirmPassword?: string) => Promise<void>;
}

class AskPasswordDialog extends DialogComponent<Props> {

  state = {
    password: '',
    confirmPassword: '',
    error: '',
    submiting: false
  }

  render() {
    const { error } = this.state;
    const { placeholder, confirm, placeholderConfirm } = this.props;
    return (
      <form className="ask-password-dialog-component" onSubmit={(e) => e.preventDefault()}>
        <InputPassword
          className="text-center"
          onChange={this.handleChangePassword}
          placeholder={placeholder ?? 'رمز عبور فعلی شما'}
          autoComplete="new-password"
        />
        {!confirm ? '' : (
          <InputPassword
            autoComplete="new-password"
            className="text-center"
            onChange={this.handleChangeConfirmPassword}
            placeholder={placeholderConfirm ?? 'تایید رمز عبور'}
          />
        )}
        {error === '' ? '' : (
          <div className="input-error-message">{error}</div>
        )}
        <div className="d-flex align-items-center justify-content-end mt-3">
          <button className="ant-btn ml-2" onClick={this.close.bind(this)}>انصراف</button>
          <button
            className="ant-btn ant-btn-primary"
            onClick={this.handleSubmitClick}>ورود به حساب</button>
        </div>
      </form>
    );
  }

  private handleChangePassword = (e: any) => this.setState({ password: e.target.value });

  private handleChangeConfirmPassword = (e: any) => this.setState({ confirmPassword: e.target.value });

  private handleSubmitClick = async () => {
    const { password, confirmPassword } = this.state;
    const { action, validatePassword } = this.props;
    if (validatePassword instanceof Function) {
      try {
        const result = validatePassword(password, confirmPassword);
        if (!result) {
          return false;
        }
      }
      catch (e) {
        this.setState({ error: e.message });
        return false;
      }
    }
    if (action instanceof Function) {
      try {
        await action(password, confirmPassword);
        this.resolve(true);
        this.close(true);
      }
      catch (e) {
        let error = (e.response &&
          e.response.status &&
          e.response.status === 401
        ) ? 'رمز عبور وارد شده اشتباه است، دوباره تلاش کنید.' : e.message;
        this.setState({ error });
        return false;
      }
    }
  }

}

export default AskPasswordDialog;
